import { CarriersController } from "../../../controllers/carriers-controller";
import { Carrier } from "../../../models/carrier"
import { CarrierFilter } from "../../../models/carrier-filter"
import { BusyService } from "../../../services/busy-service";
import { WebApiService } from "../../../services/web-api-service";
import { AureliaCookie } from 'aurelia-cookie';

import { observable, computedFrom, autoinject } from "aurelia-framework";
import { singleton } from 'aurelia-framework';
import { AppMessageService } from "../../../services/app-message-service";
import { DialogService } from "aurelia-dialog";
import { UpdateUserDialog } from "../../dialogs/update-user-dialog";
import { PageMessageService } from "../../../services/page-message-service";
import { SimpleDialog } from "../../dialogs/simple-dialog";
import { SecurityService } from "../../../services/security-service"; 6
import { TaskActionService } from "../../requests/TaskActionService";
import { UiActionButton } from "../../requests/UiActionButton";
import { IFulfillmentWidget, NewUserRequestFulfillment } from "../../requests/new-user-request/new-user-request-fulfillment";
import { CmpTaskDto } from "../../../data/typegen/dtos/cmp-task-dto";
import { CmpTaskCommentDto } from "../../../data/typegen/dtos/cmp-task-comment-dto";
import { DisplayValuePair } from "../../../data/typegen/dtos/display-value-pair";
import { TaskState } from "../../../data/enums/taskState";
import { NewUserRequestTaskDto } from "../../../data/typegen/dtos/new-user-request-task-dto";
import { RequestDto } from "../../../data/typegen/dtos/request-dto";
import { DoUiActionDto } from "../../../data/typegen/dtos/do-ui-action-dto";
import { CmpTaskBaseDto } from "../../../data/typegen/dtos/cmp-task-base-dto";
import { RequestTypeIds } from "../../../data/typegen/enums/request-type-ids";
import { Router } from 'aurelia-router';
import { ActivityStreamItemBase } from "../../../data/typegen/dtos/activity-stream-item-base";
import { RequestStateIds } from "../../../data/typegen/enums/request-state-ids";
import { RequestDetailsScreenDataDto } from "../../../data/typegen/dtos/request-details-screen-data-dto";


@autoinject()
export class TicketPage {

    public task: CmpTaskDto;
    public request: RequestDto;
    public tasks: Array<CmpTaskDto> = [];
    public activityStream: Array<ActivityStreamItemBase> = [];
    public assignedToUsers: Array<DisplayValuePair<string>> = [];
    public taskState = TaskState;
    public requestTypeIds = RequestTypeIds;
    public requestStateIds = RequestStateIds;
    public taskDetailsComponent: IFulfillmentWidget;

    private originalRequest: RequestDto;
    private saveUiAction: UiActionButton;

    public canAddComment = true;
    public carrier: Carrier;

    constructor(
        private taskActionService: TaskActionService,
        private securityService: SecurityService,
        private busyService: BusyService,
        private appMsg: AppMessageService,
        private msg: PageMessageService,
        private router: Router,
        private dialogService: DialogService,
        private api: WebApiService) {
    }


    async activate(params) {
        this.taskActionService.actionButtons.length = 0;
        await this.loadDataAsync(params.id);
    }



    async refresh() {
        await this.loadDataAsync(this.request.requestId);
    }

    async openInPlatform() {
        this.router.navigateToRoute("request-details", { id: this.request.taskId });
    }

    async scrollToAddComment() {
        const el = window.document.querySelector("#addCommentSection");
        if (el) {
            el.scrollIntoView({ inline: "start" });
            (window.document.querySelector("#addComment") as any).focus();
        }
    }

    public async doAction(uiAction: UiActionButton, validate = true) {
        this.msg.clear();
        this.appMsg.clearPageScopedMessages();

        if (uiAction.triggersSubmit) {
            await this.runValidationRules();

            var action = new DoUiActionDto<CmpTaskBaseDto>();
            action.taskDto = this.request;
            action.uiActionVerb = uiAction.key;

            // // cancel request
            // if (action.uiActionVerb == this.cancelUiAction.key) {
            //     action.actionReason = prompt("Enter a reason for the cancellation:");
            //     if (!action.actionReason) {
            //         return
            //     }
            // }

            if (uiAction.triggersSubmit) {
                var isValid = !validate || !uiAction.performValidation || await this.runValidationRules();
                if (isValid) {
                    await this.submitUiAction(action, uiAction.redirectAfterSubmit);
                }
            }
        }
    }

    private async runValidationRules() {
        // run standard rules before save
        // these rules should not require validation
    }

    submitUiAction(action: DoUiActionDto<CmpTaskBaseDto>, redirectAfterSubmit: boolean = true) {
        //this.controller.validate();
        this.busyService.on();
        return this.api.post("Tasks", "DoRequestUiAction", action)
            .then(async (result) => {


                if (redirectAfterSubmit) {
                    var redirectRoute = AureliaCookie.get('nav_stack');
                    if (redirectRoute) {
                        this.router.navigateToRoute(redirectRoute);
                        AureliaCookie.delete('nav_stack');
                        return;
                    }
                }

                this.updateUiActions();
                this.taskDetailsComponent.initUi();


                //await this.loadDataAsync(this.request.requestId);

                //var updatedTask = JSON.parse(result.response);
                //this.request = updatedTask;
                //this.originalTask = JSON.parse(JSON.stringify(this.request));
            })
            .finally(() => {
                this.busyService.off();
            });
    }

    public async post() {
        this.busyService.on();
        try {
            await this.api.post("Tasks", "PostComment", this.request);
            await this.loadDataAsync(this.request.requestId);
        } finally {
            this.busyService.off();
        }
    }

    async loadDataAsync(requestId) {
        this.busyService.on();
        return this.api.get("Tasks", "GetRequestDetailsScreenDataDto", { requestId: requestId, isExternalView: true })
            .then(async (result) => {
                if (result.response) {
                    const screenData = JSON.parse(result.response) as RequestDetailsScreenDataDto;
                    this.request = screenData.request;
                    this.tasks = screenData.tasks;
                    this.originalRequest = JSON.parse(JSON.stringify(this.request)) as RequestDto;
                    this.activityStream = screenData.activityStream.filter(o => o.isCustomerVisible);

                    this.saveUiAction = this.taskActionService.addUiActionFromTemplate(TaskActionService.saveActionTemplate);
                    this.saveUiAction.visible = false;

                    // carrier is needed for the requirements grid
                    if (this.request.variables.CarrierId) {
                        var carrierResult = await this.api.get("Carriers", "GetCarrierById", { carrierId: this.request.variables.CarrierId });
                        this.carrier = result && JSON.parse(carrierResult.response);
                    }


                    setTimeout(() => {
                        this.updateUiActions();
                    }, 100);
                }
            })
            .finally(() => {
                this.busyService.off();
            });
    }


    private updateUiActions() {
    }
}